export { default as Footer_1 } from "./Footer_1";
export { default as Footer } from "./Footer";
